import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, tap } from 'rxjs/operators';
import { HybridCommunicationService } from '@frontend-site/shared/hybrid';
import { getRegistry } from '@ngneat/elf';
import { Observable } from 'rxjs';
import { UserDetails } from '@frontend-site/shared/data';
import { AuthStore } from './auth.store';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
    constructor(
        private http: HttpClient,
        private readonly hybridCommunicationService: HybridCommunicationService,
        private readonly authStore: AuthStore
    ) {
        this.getUserDetails()
            .pipe(
                tap((user: UserDetails) => {
                    this.authStore.setUser(user);
                })
            )
            .subscribe();
    }

    logout(redirectParameter?: string): void {
        this.http
            .post<any>('/rest/security/logout', {})
            .pipe(
                map(({ result }) => result),
                map((logoutUrl: string) => (redirectParameter ? logoutUrl + '?' + redirectParameter : logoutUrl))
            )
            .subscribe((logoutUrl) => {
                this.performLogout();
                window.location.replace(logoutUrl);
            });
    }

    private performLogout(): void {
        getRegistry().forEach((store) => store.reset());
        this.hybridCommunicationService.sendLogout();
    }

    private getUserDetails(): Observable<UserDetails> {
        return this.http.get<UserDetails>('/rest/pqm/getUserDetails');
    }
}
